export default __webpack_public_path__ + "static/media/bubble.c5d37e5f.svg";